export default __webpack_public_path__ + "static/media/Chapter-4-frontcover.404805b5.png";